import { render, staticRenderFns } from "./emailHome.vue?vue&type=template&id=68666292&scoped=true"
import script from "./emailHome.vue?vue&type=script&lang=js"
export * from "./emailHome.vue?vue&type=script&lang=js"
import style0 from "./emailHome.vue?vue&type=style&index=0&id=68666292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68666292",
  null
  
)

export default component.exports